import { NestAPI } from '@marketing-milk/frontend'
import { CreativeCopyEditEvent } from '@marketing-milk/interfaces'
import { useQuery } from 'react-query'

export const creativeCopyEditsQueryKey = (businessID: number, creativeID: number | null) =>
  ['creative-copy-edits', businessID, creativeID] as const

/**
 * What an ad's copy has been changed to, and by whom.
 *
 * Employee-only on the server, deliberately: unlike the comment thread beside it
 * in the history column, this is an internal record and a client session is
 * refused it.
 */
export const useCreativeCopyEdits = (businessID: number, creativeID: number | null) => {
  const {
    data: edits = [],
    isLoading,
    isFetched,
    isError,
    refetch,
  } = useQuery<CreativeCopyEditEvent[], Error>(
    creativeCopyEditsQueryKey(businessID, creativeID),
    async () => {
      const response = await NestAPI.get<CreativeCopyEditEvent[]>(
        `businesses/${businessID}/ad-creatives/${creativeID}/copy-edits`
      )
      return response.data
    },
    {
      enabled: typeof creativeID === 'number',
      refetchOnWindowFocus: true,
      staleTime: 30_000,
    }
  )

  return { edits, isLoading, isFetched, isError, refetch }
}
